var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSaveIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 200,
  height: 200,
  fill: "#fff",
  stroke: "#fff",
  viewBox: "0 0 49 49",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M39.914 0H.5v49h48V8.586zM35.5 2v14h-24V2zm-26 45V28h29v19zm37 0h-6V26h-33v21h-5V2h7v16h28V2h1.586L46.5 9.414z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 33h7a1 1 0 1 0 0-2h-7a1 1 0 1 0 0 2zM23.5 35h-10a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zM25.79 35.29c-.181.189-.29.45-.29.71s.109.52.29.71c.189.18.439.29.71.29.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71s-.11-.521-.29-.71c-.37-.37-1.05-.37-1.42 0zM33.5 4h-6v10h6zm-2 8h-2V6h2z"
})));
export { SvgSaveIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/save-icon.svg";